import WorkOrderCuratedChip from './WorkOrderCuratedChip';

export default WorkOrderCuratedChip;
